import { Injectable } from '@angular/core';
import { DataService } from "../../../../shared/session/index";
import { SessionInfo } from "../../../../shared/session/SessionInfo";
import { HttpParams } from '@angular/common/http';
import { User } from './user.model';

@Injectable({
  providedIn: 'root',
})
export class UserService {
  constructor(private dataService: DataService, private sessionInfo: SessionInfo) { }

  private insertarUserUrl: string = 'User/Insertar';
  private actualizarUsersUrl: string = 'User/Actualizar';
  private obtenerUsersUrl: string = 'User/Obtener';
  private listarPorRoleUrl: string = 'User/ListarPorRole';
  private listarPorUrl: string = 'User/ListarPor';
  private listarPorUserUrl: string = 'User/listarPorPagina';
  private asignarRolUserUrl: string = 'RoleUser/insertar'
  private deleteRolUserUrl: string = 'RoleUser/delete'
  private listarAccesosUrl: string = 'User/listarAcceso';

  ToggleRolUser(RoleID: number, AplicacionID: number, OfficeID: number, UserID: number, identificador: boolean) {
    let parameters: string;
    parameters = JSON.stringify({
      RoleID: RoleID,
      AplicacionID: AplicacionID,
      OfficeID: OfficeID,
      UserID: UserID
    })
    if (identificador)
      this.dataService.set(this.asignarRolUserUrl);
    else
      this.dataService.set(this.deleteRolUserUrl);
    return this.dataService.execPostJson(parameters);
  }

  listarUsers(filtro: string): any {
    let parameters = new HttpParams();
    parameters = parameters.append("pFiltro", String(filtro));
    parameters = parameters.append("empresaID", String(this.sessionInfo.getEmpresaID()));
    this.dataService.set(this.listarPorUrl);
    return this.dataService.execGetJson(parameters);
  }

  listarPorUser(filtro: string, pageIndex: number, pageSize: number): any {
    let parameters = new HttpParams();
    parameters = parameters.append("pFiltro", String(filtro));
    parameters = parameters.append("pNumeroPaginas", String(pageIndex + 1));
    parameters = parameters.append("pCantidadRegistros", String(pageSize));
    parameters = parameters.append("empresaID", String(this.sessionInfo.getEmpresaID()));
    this.dataService.set(this.listarPorUserUrl);
    return this.dataService.execGetJson(parameters);
  }

  listarPorRole(RoleID: number, filtro: string): any {
    let parameters = new HttpParams();
    parameters = parameters.append("pRoleID", String(RoleID));
    parameters = parameters.append("pFiltro", String(filtro));
    parameters = parameters.append("idNivelAcceso", String(this.sessionInfo.getIdNivelAcceso()));
    parameters = parameters.append("idEntidad", String(this.sessionInfo.getIdEntidad()));
    this.dataService.set(this.listarPorRoleUrl);
    return this.dataService.execGetJson(parameters);
  }

  obtenerUser(codUser: number): any {
    let parameters = new HttpParams();
    parameters = parameters.append("pKey", String(codUser));
    this.dataService.set(this.obtenerUsersUrl);
    return this.dataService.execGetJson(parameters);;
  }

  insertarUser(user: User): any {
    let parameters: string;
    parameters = JSON.stringify({
      UserName: user.UserName,
      DNI: user.DNI,
      Direccion: user.Direccion,
      Telefono: user.Telefono,
      Correo: user.Correo,
      FechaNac: user.FechaNac,
      FechaIng: user.FechaIng,
      Password: user.Password,
      description: user.Description,
      systemPersonId: user.SystemPersonID,
      UserCreation: this.sessionInfo.getCodUsuario(),
      FotoRuta: user.FotoRuta,
      EmpresaID: this.sessionInfo.getEmpresaID(),
      claseArchivo: user.claseArchivo,
      UserShortName: user.UserShortName,
      imagenReverso: user.imagenReverso,
      seguimiento: user.seguimiento,
    });
    this.dataService.set(this.insertarUserUrl);
    return this.dataService.execPostJson(parameters);
  }

  actualizarUser(user: User): any {
    let parameters: string;
    parameters = JSON.stringify({
      ID: user.ID,
      UserName: user.UserName,
      DNI: user.DNI,
      Direccion: user.Direccion,
      Telefono: user.Telefono,
      Correo: user.Correo,
      FechaNac: user.FechaNac,
      FechaIng: user.FechaIng,
      Password: user.Password,
      description: user.Description,
      systemPersonId: user.SystemPersonID,
      Status: user.Status,
      userlastupdate: this.sessionInfo.getCodUsuario(),
      FotoRuta: user.FotoRuta,
      claseArchivo: user.claseArchivo,
      UserShortName: user.UserShortName,
      imagenReverso: user.imagenReverso,
      seguimiento: user.seguimiento,
      editarToken: user.editarToken,
      multipleSesion: user.multipleSesion,
      seguimientoUbicacion: user.seguimientoUbicacion,
      autonomia: user.autonomia,
    });
    this.dataService.set(this.actualizarUsersUrl);
    return this.dataService.execPostJson(parameters);
  }

  listarAccesoUsuario(filtro: string, idAplicacion: number, idNivelAcceso: number, idEntidad: number, idRol: number): any {
    let parameters = new HttpParams();
    parameters = parameters.append("pFiltro", String(filtro));
    parameters = parameters.append("idAplicacion", String(idAplicacion));
    parameters = parameters.append("idNivelAcceso", String(idNivelAcceso));
    parameters = parameters.append("idEntidad", String(idEntidad));
    parameters = parameters.append("idRol", String(idRol));
    parameters = parameters.append("idEmpresa", String(this.sessionInfo.getEmpresaID()));
    this.dataService.set(this.listarAccesosUrl);
    return this.dataService.execGetJson(parameters);
  }
}